
import React from "react";
import { Interview } from "@/types/interview";
import InterviewHeader from "../InterviewHeader";
import InterviewActions from "./InterviewActions";
import InterviewContainer from "./InterviewContainer";
import ContentLayout from "./ContentLayout";
import ExpandButton from "./ExpandButton";
import ExpandedContent from "./ExpandedContent";
import { useInterviewCard } from "@/hooks/interview/useInterviewCard";

interface InterviewCardProps extends Interview {
  isReversed?: boolean;
  articleNumber?: number;
}

const InterviewCard = (props: InterviewCardProps) => {
  const {
    id,
    question,
    answer,
    intervieweeName,
    title,
    jobTitle,
    company,
    context,
    contextUrl,
    contextImageUrl,
    contextImageCaption,
    tags,
    isReversed = false,
    aiSummary,
    aiResponse,
    articleNumber,
    isBookmarked = false,
    isLiked = false,
    summary_status = 'completed',
    summary_error,
    photoUrl
  } = props;

  const {
    isExpanded,
    setIsExpanded,
    aiChat,
    handleAiQuestion,
    handleAiResponse,
    wordCount,
    renderKey,
    validTimestamp,
    readingTime,
    audioDuration,
    processedSummary
  } = useInterviewCard(props);

  return (
    <InterviewContainer isReversed={isReversed} intervieweeName={intervieweeName}>
      <InterviewHeader 
        timestamp={validTimestamp}
        answer={answer}
        aiSummary={processedSummary} // Use processedSummary instead of aiSummary directly
        aiResponse={aiResponse}
        articleNumber={articleNumber || 0}
        wordCount={articleNumber === 1 ? wordCount : undefined}
        isLiked={isLiked}
        isBookmarked={isBookmarked}
        context={context}
        question={question}
        intervieweeName={intervieweeName}
        title={title}
        company={company}
        readingTime={readingTime}
        audioDuration={audioDuration}
        id={id}
      />

      <InterviewActions />

      <ContentLayout 
        isReversed={isReversed}
        context={context}
        contextUrl={contextUrl}
        contextImageUrl={contextImageUrl}
        contextImageCaption={contextImageCaption}
        question={question}
        answer={answer}
        intervieweeName={intervieweeName}
        title={title}
        jobTitle={jobTitle}
        company={company}
        tags={tags}
        isExpanded={isExpanded}
        photoUrl={photoUrl}
        interviewId={id}
        key={`content-${renderKey}`}
      />
      
      <ExpandedContent
        isExpanded={isExpanded}
        aiSummary={processedSummary} // Use processedSummary instead of aiSummary
        aiResponse={aiResponse}
        aiChat={aiChat}
        onAiQuestion={handleAiQuestion}
        onAiResponse={handleAiResponse}
        summary_status={summary_status}
        summary_error={summary_error}
        context={context}
        question={question}
        answer={answer}
        intervieweeName={intervieweeName}
        title={title}
        company={company}
        interviewId={props.id}
      />
      
      <ExpandButton 
        isExpanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      />
    </InterviewContainer>
  );
};

export default InterviewCard;
